import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar'; // Import MatSnackBar

@Injectable({
  providedIn: 'root'
})
export class UtilsService {

  constructor(
    private snackBar: MatSnackBar // Inject MatSnackBar
  ) { }

  openSnackBar(msg: string, type: 'error' | 'success' | null = null) {
    let panelClass = '';
    switch (type) {
      case 'error':
        panelClass = 'snack-bar-error';
        break;
      case 'success':
        panelClass = 'snack-bar-success';
        break;
      default:
        panelClass = 'snack-bar-generic';
        break;
    }

    this.snackBar.open(msg, 'Chiudi', {
      duration: 3000,
      verticalPosition: 'bottom',
      horizontalPosition: 'center',
      panelClass: ['snack-bar', panelClass]
    });
  }

  formatPrice(price: number) {
    return this.roundPrice(price).toString().replace('.', ',');
  }

  roundPrice(price: number) {
    return Number(price.toFixed(2));
  }
}
